
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface PostActionModalProps {
  open: boolean;
  onClose: () => void;
  toolSlug: string;
}

export function PostActionModal({ open, onClose, toolSlug }: PostActionModalProps) {
  const navigate = useNavigate();
  
  const toolMessages: Record<string, { title: string; message: string }> = {
    compressapic: {
      title: "Image compressée avec succès !",
      message: "Crée un compte pour sauvegarder automatiquement tes prochaines images.",
    },
    shortatrack: {
      title: "Lien court créé avec succès !",
      message: "Crée un compte pour gérer et suivre les statistiques de tous tes liens.",
    },
    genpersona: {
      title: "Persona généré avec succès !",
      message: "Crée un compte pour sauvegarder et gérer tous tes personas.",
    },
    roiquick: {
      title: "Analyse ROI terminée !",
      message: "Crée un compte pour sauvegarder tes analyses et y accéder à tout moment.",
    },
    tabliwizz: {
      title: "Graphique créé avec succès !",
      message: "Crée un compte pour sauvegarder tes graphiques et données.",
    },
    planifica: {
      title: "Planning mis à jour !",
      message: "Crée un compte pour sauvegarder ton planning et y accéder sur tous tes appareils.",
    },
    pagespeedcheck: {
      title: "Analyse de site terminée !",
      message: "Crée un compte pour sauvegarder tes analyses et suivre les progrès.",
    },
    biznamegenr: {
      title: "Noms d'entreprise générés !",
      message: "Crée un compte pour sauvegarder tes idées de noms et générer plus de suggestions.",
    },
    fairclick: {
      title: "Action réussie !",
      message: "Crée un compte pour maximiser tes échanges de trafic avec d'autres sites.",
    },
    default: {
      title: "Action réussie !",
      message: "Crée un compte pour enregistrer tes prochaines actions dans ton espace personnel.",
    },
  };
  
  const { title, message } = toolMessages[toolSlug.toLowerCase()] || toolMessages.default;
  
  const handleSignUp = () => {
    navigate("/auth?tab=signup");
    onClose();
  };
  
  const handleSignIn = () => {
    navigate("/auth?tab=signin");
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center text-xl font-bold mb-2">
            {title}
          </DialogTitle>
          <DialogDescription className="text-center">
            {message}
          </DialogDescription>
        </DialogHeader>
        
        <div className="flex flex-col gap-4 mt-4">
          <Button onClick={handleSignUp} className="w-full">
            Créer un compte gratuitement
          </Button>
          <Button onClick={handleSignIn} variant="outline" className="w-full">
            Se connecter
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
